import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { PATHS } from 'constants';
import IfCan from 'containers/IfCan';
import LeftNav from 'components/default/LeftNav';

import A220Logs from './A220Logs';
import AircraftPayloads from './AircraftPayloads';

import styles from './styles.module.css';

const NavMap = {
  '': [
    {
      display: 'A220 Logs',
      id: 'a220Logs',
    },
    {
      display: 'Aircraft Payloads',
      id: 'aircraftPayloads',
    },
  ],
};

const Maintenance = ({ rAircraftList, rAircraftMap }) => {
  const defaultPage = 'a220Logs';

  const location = useLocation();
  const navigate = useNavigate();

  const pathParams = location.pathname?.split('/');
  const selectedSection = pathParams[2] ? pathParams[2] : defaultPage;

  const renderMenuItem = () => {
    switch (selectedSection) {
      case 'aircraftPayloads':
        return <AircraftPayloads aircraftMap={rAircraftMap} />;
      default:
        return <A220Logs aircraftList={rAircraftList} />;
    }
  };

  return (
    <IfCan allowedRoles={['Maintenance']} alternateContent={<></>}>
      <Row className={styles.root} data-cy-id="Maintenance" noGutters>
        <Col md="auto" className={styles.leftPanel}>
          <LeftNav
            activeMenuItem={!selectedSection ? 'a220Logs' : selectedSection}
            changeActiveMenu={(id) => {
              navigate(`${PATHS.maintenance}/${id}`);
            }}
            navMap={NavMap}
            primaryHeader="Maintenance"
            testIdPrefix="Maintenance"
          />
        </Col>
        <Col className={styles.container}>{renderMenuItem()}</Col>
      </Row>
    </IfCan>
  );
};

const state = (state) => {
  return {
    rAircraftList: state.aircraftList,
    rAircraftMap: state.aircraftMap,
    user: state.user,
  };
};

const actions = {};

export default connect(state, actions)(Maintenance);
